<template>
  <div class="producto w-100">
    <div class="contenedor-producto">
      <div v-for="(item,index) in DetalleProducto" :key="index">
        <!-- --------------------------------Portada-------------------------------- -->
        <div class="contenedor">
          <div class="portada d-flex align-items-center justify-content-center py-5">
            <div class="row text-lg-left">
              <div class="col-12 col-lg-4">
                <titulo-seccion>Aumenta las ventas de tu negocio con {{item.nombre}}</titulo-seccion>
                <p>
                  Gestiona tu sistema de distribución
                  móvil en la web y disfruta de sus funciones
                </p>
                <div>
                  <ul class="lista-producto list-unstyled">
                    <li>- Análisis de datos</li>
                    <li>- Mide la efectividad</li>
                    <li>- Interfaz intuitiva</li>
                    <li>- Datos en gráficos</li>
                    <li>- Reportes de datos</li>
                  </ul>
                </div>
              </div>
              <div class="col-12 col-lg-8 pt-3 pt-lg-0">
                <div>
                  <img
                    :src="item.imagenDashboard"
                    :title="item.descripcion"
                    class="shadow"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Portada -->
        <!-- Clientes Relacionados -->
        <div class="contenedor borde-sombreado bg-light">
          <cliRelacionados class="py-5" :id_prod="item.id" />
        </div>
        <!-- Fin Clientes Relacionados  -->
        <!-- Interfaz Sencilla -->
        <div class="contenedor">
          <div class="py-5">
            <titulo-seccion class="m-0">Interfaz simple y fácil de usar</titulo-seccion>
            <p
              class="m-0 pt-2"
            >Ntico Web te permite realizar muchas tareas en poco tiempo con su increíble interfaz</p>
            <div class="row">
              <div class="contenedor-img mt-4 col-12 col-md-6 p-3">
                <img
                  :src="item.imagenMapaClientes"
                  class="shadow"
                  :title="item.descripcion"
                  width="100%"
                />
              </div>
              <div class="contenedor-img mt-4 col-12 col-md-6 p-3">
                <img
                  :src="item.imagenReportesActividades"
                  class="shadow"
                  :title="item.descripcion"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Interfaz Sencilla -->
        <!-- Caracteristicas -->
        <div class="contenedor bg-light borde-sombreado">
          <div class="contenedor-caracteristicas py-5">
            <titulo-seccion class="pb-3">
              ¿Qué puedes hacer con el
              <strong>{{item.nombre}}</strong>?
            </titulo-seccion>
            <div class="subcontenedor-caracteristicas row">
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-chart-line icono icono-venta"></i>
                <h1>Análisis</h1>
                <p>Analiza los ingresos, efectividad, cotizaciones y ventas</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-file-invoice icono icono-reportes"></i>
                <h1>Reportes</h1>
                <p>Realiza reportes de ventas, actividades, cuentas, cobros y devoluciones</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-map-marked-alt icono icono-mapas"></i>
                <h1>Mapas</h1>
                <p>Gestiona la localización de clientes y rutas de ventas</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-mobile icono icono-dispositivos"></i>
                <h1>Dispositivos</h1>
                <p>Administra todos los dispositivos conectados al sistema</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Caracteristicas -->
        <!-- Enlace -->
        <div class="contenedor">
          <div class="py-5">
            <titulo-seccion>
              ¡Descubre más de
              <b>{{item.nombre}}</b>!
            </titulo-seccion>
            <p
              class="py-2"
              style="font-size: 1.4em; color: #595959"
            >El mejor sistema de distribución móvil</p>
            <boton-enlace to="/SdmMovil" size="lg">Hazlo Ahora</boton-enlace>
          </div>
        </div>
        <!-- Enlace -->

        <!-- Reportes Avanzado -->
        <div class="contenedor bg-light borde-sombreado">
          <div class="py-5">
            <titulo-seccion class="pb-3">Reportes Avanzados</titulo-seccion>
            <div class="row">
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-running icono icono-reporte"></i>
                <p>Actividades</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-tag icono icono-reporte"></i>
                <p>Venta</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-search-dollar icono"></i>
                <p>Cobros</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-hand-holding-usd icono"></i>
                <p>Devoluciones</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-shopping-bag icono"></i>
                <p>Ventas por Productos</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-cash-register icono"></i>
                <p>Cuentas por Cobrar</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-credit-card icono"></i>
                <p>Cobros por Adelanto</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-hourglass-half icono"></i>
                <p>Duración por Venta</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-file-invoice-dollar icono"></i>
                <p>Depósitos de Factura</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-business-time icono"></i>
                <p>Horas Trabajadas</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-people-carry icono"></i>
                <p>Visita Efectiva</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fab fa-creative-commons-nc icono"></i>
                <p>Visita No Ventas</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Reportes Avanzado -->

        <!-- Contacto -->
        <div class="contenedor">
          <div class="py-5">
            <titulo-seccion class="pb-3">Para saber más de Ntico</titulo-seccion>
            <div class="row justify-content-center">
              <div class="col-12 col-md-4">
                <div style="font-size: 3.7em; color: #595959;" class="mt-3 mb-1">
                  <i class="fas fa-phone-volume"></i>
                </div>
                <p style="font-size: 1.2em;">+1 (809) 241 7309</p>
              </div>

              <div class="col-12 col-md-4">
                <div style="font-size: 3.7em; color: #595959;" class="mt-3 mb-1">
                  <i class="fas fa-mail-bulk"></i>
                </div>
                <router-link to style="font-size: 1.2em;">contacto@adgsystems.com.do</router-link>
              </div>
              <div class="col-12 col-md-4">
                <div style="font-size: 3.7em; color: #595959;" class="mt-3 mb-1">
                  <i class="fas fa-map-marker-alt info-icon"></i>
                </div>
                <router-link
                  to
                  style="font-size: 1.2em;"
                >Calle 16 de Agosto, Edif Julian Ramia, Mod 3A. Santiago, R.D.</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Contacto -->
      </div>
    </div>
  </div>
</template>
<script>
import cliRelacionados from "@/components/cliente/ClientesRelacionados.vue";
import { mapState } from "vuex";
export default {
  name: "product",
  data() {
    return {
      DetalleProducto: []
    };
  },
  components: {
    cliRelacionados
  },
  computed: {
    ...mapState(["Productos", "Clientes"])
  },
  created() {
    window.scrollTo(0, 0);
    this.producto();
    this.$store.state.colorHeader = true;
  },
  destroyed() {
    this.$store.state.colorHeader = false;
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    producto() {
      /* Productos */
      this.Productos.forEach(item => {
        if (item.id == 3) {
          this.DetalleProducto.push(item);
        }
      });
    }
  }
};
</script>
<style scoped>
/* Portada */
.contenedor-producto {
  padding-top: 60px;
}
.portada {
  min-height: 60vh;
  width: 100%;
  color: #009cff;
}
.portada img {
  max-height: 70vh;
  max-width: 100%;
  width: auto;
}
.lista-producto {
  color: #595959;
  font-weight: 300;
}
.lista-producto {
  font-size: calc(1em + 0.5vw);
}
/* Fin Portada */
/* Contenido */
.contenedor {
  padding: 0 6%;
}
.borde-sombreado {
  -webkit-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  -moz-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
}
.contenedor .contenedor-caracteristicas {
  padding: 0 6%;
}
.contenedor p,
.contenedor a {
  color: rgba(0, 0, 0, 0.7);
  font-size: calc(0.9em + 0.5vw);
  font-weight: 400;
}
@media screen and (max-width: 768px) {
  .contenedor p,
  .contenedor a {
    margin: 0;
    font-size: calc(1.1em + 0.5vw);
  }
}
/* --------- */
/* Seccion Caracteristicas */
.contenedor-caracteristicas h1,
.titulo-objetivos {
  padding-top: 14px;
  font-size: calc(1.2em + 0.5vw);
  color: #262626;
}
.caracteristica p {
  margin-top: 0px;
  color: #595959;
  font-weight: 500;
  letter-spacing: -0.2px;
  font-size: calc(0.8em + 0.5vw);
  margin-bottom: 7px;
}
@media screen and (max-width: 768px) {
  .caracteristica p {
    font-size: calc(1em + 0.5vw);
  }
}
.caracteristica {
  margin-bottom: 20px;
}
.caracteristica .icono {
  border-radius: 200px;
  width: 90px;
  height: 90px;
  padding: 22px;
  color: white;
  background: #009cff;
}
/* Fin Caracteristicas */
/* Seccion imagenes */
.portada img {
  object-fit: cover;
  display: block;
}
/* --------------- */
/* Reportes */
.reporte {
  margin: 20px 0px;
  display: flex;
  align-items: center;
}
.reporte .icono {
  border-radius: 200px;
  width: 74px;
  height: 74px;
  padding: 18px;
  color: white;
  -moz-box-shadow: 1px 1px 4px rgba(20, 89, 186, 0.3);
  -webkit-box-shadow: 1px 1px 4px rgba(20, 89, 186, 0.3);
  box-shadow: 1px 1px 4px rgba(20, 89, 186, 0.3);
  background: #009cff;
}
.reporte p {
  text-align: left;
  margin-left: 12px;
  word-break: normal;
  font-size: 1.34em;
  font-weight: 400;
  color: #262626;
  letter-spacing: -0.5px;
}

/* ---- */
</style>
